'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * 配合 `selectOnFocus`，在 `onFocus` 中就 call `onChange`
                                                                                                                                                                                                                                                                               * 這樣填入值之後才能被 select
                                                                                                                                                                                                                                                                               * 而不是 didUpdate 之後用 `isFocused`，來決定填入
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * 放入 input state 之下，onBlur 之後再更新 root state
                                                                                                                                                                                                                                                                               * 摸擬使用者輸入行為，才不會過早啟動公式重算
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * 放入 input state 之外，直接修改 doc state，可以填入值是否有效
                                                                                                                                                                                                                                                                               * 與造成的效果更早顯現出來
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Smart Input
                                                                                                                                                                                                                                                                               * 配合同一類欄位之前的輸入值來設定填入值，將值放在 redux store 裡
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * 優先放在 input state 之外，因為預設值不一定是 string，應該要是 doc 中的 type
                                                                                                                                                                                                                                                                               */

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _branch = require('recompose/branch');

var _branch2 = _interopRequireDefault(_branch);

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _lifecycle = require('recompose/lifecycle');

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _withHandlers = require('recompose/withHandlers');

var _withHandlers2 = _interopRequireDefault(_withHandlers);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _autofill = require('./autofill');

var _linkHandlersBefore = require('coact-utils/linkHandlersBefore');

var _linkHandlersBefore2 = _interopRequireDefault(_linkHandlersBefore);

var _ramda = require('ramda');

var _bindHotKeys = require('coact-utils/bindHotKeys');

var _bindHotKeys2 = _interopRequireDefault(_bindHotKeys);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function normalizeAutofill(autofill) {
  if ((typeof autofill === 'undefined' ? 'undefined' : _typeof(autofill)) === 'object') {
    return _extends({ fill: function fill(v) {
        return v;
      }, manual: false }, autofill);
  }
  return { key: autofill, fill: function fill(v) {
      return v;
    }, manual: false };
}

function selectAutofill(state, props) {
  var autofill = props.autofill;

  var prevInput = state.autofill[autofill.key];
  if (prevInput === undefined) return {};

  var valueToFill = autofill.fill(prevInput);

  return {
    valueToFill: valueToFill
  };
}
function makeHandlers(dispatch, props) {
  var autofill = props.autofill;


  return {
    cacheInput: function cacheInput(input) {
      return dispatch(_autofill.actions.cacheInput({
        key: autofill.key,
        value: input
      }));
    }
  };
}

function _fillValue(_ref) {
  var valueToFill = _ref.valueToFill,
      onChange = _ref.onChange;

  if (valueToFill !== undefined) {
    onChange(valueToFill);
  }
}

var oneOfType = _propTypes2.default.oneOfType,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string,
    func = _propTypes2.default.func,
    any = _propTypes2.default.any,
    bool = _propTypes2.default.bool;

var enhancer = (0, _branch2.default)(function (_ref2) {
  var autofill = _ref2.autofill;
  return !!autofill;
}, (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  autofill: oneOfType([string, shape({ key: string, fill: func, manual: bool })]).isRequired,
  onFocus: func
}), (0, _injectProps2.default)({
  value: any,
  onChange: func.isRequired
}), (0, _withProps2.default)(function (_ref3) {
  var autofill = _ref3.autofill;
  return { autofill: normalizeAutofill(autofill) };
}), (0, _reactRedux.connect)(selectAutofill, makeHandlers), (0, _lifecycle2.default)({
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.props.cacheInput(this.props.value);
    }
  }
}), (0, _withHandlers2.default)({
  fillValue: function fillValue(props) {
    return function () {
      return _fillValue(props);
    };
  }
}), (0, _branch2.default)(function (_ref4) {
  var autofill = _ref4.autofill;
  return !autofill.manual;
}, (0, _withHandlers2.default)((0, _linkHandlersBefore2.default)({
  onFocus: function onFocus(props) {
    return function () {
      if ((0, _ramda.isNil)(props.value) || (0, _ramda.isEmpty)(props.value)) props.fillValue();
    };
  }
})), (0, _bindHotKeys2.default)({
  fillValue: 'ctrl+up'
})), (0, _exposeProps2.default)(['onFocus'])));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'autofillOnFocus');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/enhancers/autofillOnFocus/index.js
// module id = 1683
// module chunks = 0